<template>
	<perfect-scrollbar class="setting_ps px-7 py-4" style="margin-top: 70px">
		<div class="pt-4">
			<v-row no-gutters>
				<v-col cols="12" class="text-right mt-2 pr-3">
					<SecondaryButton v-if="canCreateNewConnection" @click="connectProfile">Add Connection</SecondaryButton>
					<ConnectProfileDialog :showDialog.sync="connectDialog" />
				</v-col>
			</v-row>
		</div>
		<v-row no-gutters v-if="!noProfiles">
			<v-col cols="12">
				<SettingsTable title="My Profiles" :sourceList="userProfiles">
					<template v-slot:item="{ item: profile }">
						<SettingsProfilesListItem class="mb-2" :key="profile.id" :profileData="profile" />
					</template>
				</SettingsTable>
				<SettingsTable title="Shared with Me" :sourceList="sharedProfiles">
					<template v-slot:item="{ item: profile }">
						<SettingsProfilesListItem class="mb-2" :key="profile.id" :profileData="profile" />
					</template>
				</SettingsTable>
			</v-col>
		</v-row>
		<div v-else class="flex-centerize mt-12 pt-12">
			<AppLoader v-if="isLoading" />
			<div v-else>No connections yet.</div>
		</div>
	</perfect-scrollbar>
</template>

<script>
import SettingsTable from './SettingsTable';
import { mapActions } from 'vuex';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { getAllAccountConnections } from '@/store/modules/credentials/getters';
import ConnectProfileDialog from '@/components/Settings/ProfilesConnectNewDialog';
import SettingsProfilesListItem from '@/components/Settings/SettingsProfilesListItem';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'SettingsProfiles',
	components: {
		SettingsTable,
		ConnectProfileDialog,
		SettingsProfilesListItem,
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, getAllAccountConnections }),
		userProfiles() {
			return Object.values(this.getAllAccountConnections);
		},
		sharedProfiles() {
			return [];
		},
		noProfiles() {
			return !(this.userProfiles.length > 0 || this.sharedProfiles.length > 0);
		},
		canCreateNewConnection() {
			return this.hasAccountPermission(AccountPermissions.CreateWorkflows);
		},
	},
	methods: {
		...mapActions(['credentials/getUserCredentials']),
		async getAppProfiles() {
			this.isLoading = false;
			try {
				await this['credentials/getUserCredentials']({ forceGet: true });
			} finally {
				this.isLoading = true;
			}
		},
		connectProfile() {
			this.connectDialog = true;
		},
	},
	mounted() {
		this.getAppProfiles();
	},
	data: () => ({
		isLoading: false,
		connectDialog: false,
	}),
};
</script>

<style lang="scss" scoped>
.scroll {
	overflow-y: auto;
}
</style>
